const isLocal = window.location.hostname === 'localhost';
const BaseUrl = isLocal ? 'http://localhost:8090' : 'https://merrell-1h23-6hg2nl4gha-uc.a.run.app';
///
export class HttpError extends Error {
    constructor(code, message) {
        super(message);
        this.status = code;
    }
}
const getHeaders = () => {
    const token = localStorage.getItem('token');
    return Object.assign(Object.assign({}, token ? { 'Authorization': token } : {}), { 'Content-Type': 'application/json', 'Accept': 'application/json' });
};
async function parseResponse(response) {
    const text = await response.text();
    if (response.status < 200 || response.status >= 300) {
        throw new HttpError(response.status, text);
    }
    try {
        return JSON.parse(text);
    }
    catch (e) {
        return text;
    }
}
async function getJson(url) {
    const response = await fetch(url, {
        headers: getHeaders()
    });
    return await parseResponse(response);
}
async function sendJson(url, data, method) {
    const response = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(data)
    });
    return await parseResponse(response);
}
const getPath = path => `${BaseUrl}/api/${path}`;
const postJson = (relPath, data) => sendJson(getPath(relPath), data, 'POST');
const putJson = (relPath, data) => sendJson(getPath(relPath), data, 'PUT');
export const sendHelpTicket = data => postJson('help-ticket', data);
export const getUser = id => getJson(getPath(`user/${id}`)).then((user) => ({
    firstName: user.firstName,
    lastName: user.surname
}));
export const login = (email, password) => postJson('login', { email, password }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
;
export const register = (firstname, lastname, email, phone, zip, password, bridgestoneId) => postJson('register', { firstname, lastname, email, phone, zip, password, bridgestoneId }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
export const join = (firstname, lastname, email, country) => postJson('join', { firstname, lastname, email, country }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
export const emailExists = async (email) => {
    const response = await fetch(getPath('email-check'), {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ email })
    });
    if (response.status === 404)
        return false;
    if (response.status === 200)
        return true;
    throw new Error(await response.text());
};
export const setPreinvitePassword = (email, password) => postJson('set-password', {
    email,
    passwordNew: password,
    passwordConfirm: password
});
export const forgotPassword = email => postJson('forgot-password', { email });
export const resetPassword = (token, password) => postJson('password', { token, password });
const Schedule = [
    {
        id: '1h23',
        title: '1H23 Digital Conference',
        desc: 'Welcome to the 1H23 dGBC General Session where we will kick off this season with our Merrell Senior Leadership Team and introductions to our Key Stories with Marketing, Product Development, and Sales.',
        speakerData: [],
        stream: {
            live: {
                type: 'livestream',
                url: 'https://livestream.com/accounts/29318962/events/10342401'
            },
            replay: undefined
        },
        startDate: '2022/04/20',
        startTime: '7:00',
        timeZone: 'EDT',
        duration: 65 * 60
    }
];
export const getSchedule = () => 
// getJson(getPath('schedule/'))
Promise.resolve(Schedule)
    .then(events => events.map(event => {
    // Some browers require date string with / vs -
    const startTime = new Date(`${event.startDate.replaceAll('-', '/')} ${event.startTime} ${event.timeZone}`);
    const endTime = new Date(startTime.getTime() + event.duration * 1000);
    // Clean server data
    return {
        id: event.id,
        title: event.title,
        description: event.desc,
        duration: event.duration,
        speakers: event.speakerData,
        stream: event.stream,
        startTime,
        endTime
    };
}).sort((a, b) => a.startTime - b.startTime));
const Assets = {
// 'driving': {
//   openDateTime: "2021/08/10 09:0:0 CDT",
//   beforeOpenText: 'Assets will become available on August 10th at 9am CST and will be available until August 24th',
//   title: 'Potenza Sport Virtual Reality Driving Experiences',
//   subtitle: 'This content is filmed on a closed course with a professional driver.',
//   assets: [
//     {title: "Introduction to Potenza Sport", url: 'https://player.vimeo.com/video/574452857?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//     {title: "Dry Braking", url: 'https://player.vimeo.com/video/572233734?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//     {title: "Straight Stability and Cornering", url: 'https://player.vimeo.com/video/574452359?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//     {title: "Wet Performance", url: 'https://player.vimeo.com/video/574452741?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//   ]
// },
// 'technology': {
//   openDateTime: "2021/08/10 09:0:0 CDT",
//   beforeOpenText: 'Assets will become available on August 10th at 9am CST and will be available until August 24th',
//   title: 'Tire Technology Videos',
//   assets: [
//     {title: 'Potenza 980AS Engineer Talk', url: 'https://player.vimeo.com/video/584904435?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//     {title: 'Potenza Sport Engineer Talk', url: 'https://player.vimeo.com/video/584898740?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//     {title: 'Engineering and Chemistry Talk', url: 'https://player.vimeo.com/video/584902396?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//     {title: 'Tire Trends and Tech Talk', url: 'https://player.vimeo.com/video/584903432?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'}
//   ]
// },
// 'marketing': {
//   openDateTime: "2021/08/10 09:0:0 CDT",
//   beforeOpenText: 'Assets will become available on August 10th at 9am CST and will be available until August 24th',
//   title: 'Marketing Materials',
//   assets: [
//     {title: 'Potenza Sport Sales Sheet', url: '/static/SS_EN_BS_POTENZA_SPORT.PDF', type: 'pdf'},
//     {title: 'Potenza RE980AS+ Sales Sheet', url: '/static/SS_EN_BS_POTENZA_RE980AS_PLUS.pdf', type: 'pdf'},
//     {title: 'Potenza Responsive Handling Short Video', url: 'https://player.vimeo.com/video/575830972?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//     {title: 'Potenza Responsive Handling Long Video', url: 'https://player.vimeo.com/video/575829362?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
//   ]
// }
};
export const getAssets = id => Promise.resolve(Assets[id] || Object.values(Assets)[0]);
export const getNewPartners = () => {
    return [];
};
